import React from 'react';
import styled from 'styled-components';
import { Nav, Link, Icon } from 'components/elements';
import LogoImage from 'static/img/logo.png';
import CONSTS from 'components/elements/_constants';

const LogoBarComp = ({className}) => (
  <div className={className}>
    <img src={LogoImage} alt="Bahraman Logo" />
  </div>
);
export const LogoBar = styled(LogoBarComp)`
  /* height: 50px; */
  padding: 15px 25px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, .03);
  img{
    max-width: 100%;
  }
`;

const TopBarComp = ({className, auth}) => (
  <div className={className}>
    <div class={`${className}__messages`}>
      <Link to="/messages/">
        <Icon fa icon="envelope" /> پیام‌ها
      </Link>
    </div>
    <div>{auth?.user?.first_name} {auth?.user?.last_name}</div>
  </div>
);
export const TopBar = styled(TopBarComp)`
  height: 65px;
  background-color: #fff;
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  border-bottom: 1px solid rgba(0,0, 0, .06);
  box-shadow: 0px 0 15px rgba(0, 0, 0, .05);
  text-align: left;
  &__messages{
    a{
      color: ${CONSTS.colors.greyDark};
    }
  }
`;

const SideNavComp = ({ className, onLogout }) => {
  const handleLogout = (e) => {
    e.preventDefault();
    if (!window.confirm('از پنل مدیریت خارج می‌شوید؟')) {
      return;
    }
    onLogout();
  };
  return (
    <Nav style={{ border: '1px solid' }}>
      <Nav.Item icon="dashboard" to="/">داشبورد</Nav.Item>
      <Nav.Item icon="th-large" to="/products/">محصولات</Nav.Item>
      <Nav.Item icon="list" to="/categories/">دسته‌بندی</Nav.Item>
      <Nav.Item icon="certificate" to="/certificates/">گواهینامه‌ها</Nav.Item>
      <Nav.Item icon="history" to="/histories/">تاریخچه</Nav.Item>
      <Nav.Item icon="info" to="/timelines/">درباره ما</Nav.Item>
      <Nav.Item icon="star" to="/featureitems/">ویژگی ها</Nav.Item>
      <Nav.Item icon="address-card" to="/contacts/">ارتباط با ما</Nav.Item>
      <Nav.Item icon="ellipsis-h" to="/menuitems/">منوها</Nav.Item>
      <Nav.Item icon="film" to="/slideshowitems/">اسلایدشو</Nav.Item>
      <Nav.Item icon="tag" to="/posts/">پست ها</Nav.Item>
      <Nav.Item icon="cogs" to="/options/">تنظیمات</Nav.Item>
      <Nav.Item href="#" icon="angle-right" onClick={handleLogout}>خروج</Nav.Item>
    </Nav>
  );
};
export const SideNav = styled(SideNavComp)``;
